// Source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/en.xml#L1847
module["exports"] = {
  wide: [
    "söndag",
    "måndag",
    "tisdag",
    "onsdag",
    "torsdag",
    "fredag",
    "lördag"
  ],
  abbr: [
    "sön",
    "mån",
    "tis",
    "ons",
    "tor",
    "fre",
    "lör"
  ]
};



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/date/weekday.js
// module id = 1391
// module chunks = 0